var exports = {
  "kL": "x805b157e--6f2901--container",
  "Ju": "x805b157e--6f2901--desktop-container",
  "mg": "x805b157e--6f2901--search-input",
  "EK": "x805b157e--6f2901--suggests",
  "n9": "x805b157e--6f2901--desktop-suggests",
};

module.exports = exports;
